const DEFAULT_BACKEND_DATE_FORMAT = 'dd-MM-yyyy'
const DEFAULT_BACKEND_DATE_FORMAT_REVERSE = 'yyyy-MM-dd'

type DateFormat =
  | typeof DEFAULT_BACKEND_DATE_FORMAT
  | typeof DEFAULT_BACKEND_DATE_FORMAT_REVERSE

/**
 * Converts a date string to a Date object
 * @param time - Date string in the format specified by the format parameter
 * @param format - Date format to parse (default: 'dd-MM-yyyy')
 * @returns Date object
 */
export default function unformatDate(
  time: string | null | undefined,
  format: DateFormat = DEFAULT_BACKEND_DATE_FORMAT
): Date {
  if (time && typeof time === 'string') {
    const parts = time.split(' ')
    const splitTime: string[] | undefined = parts[1]
      ? parts[1].split(':')
      : undefined
    const pattern = /-/.test(time) ? '-' : '/'
    const splitDate = time.slice(0, 10).split(pattern)

    if (splitDate.length !== 3) {
      return new Date()
    }

    const t = {
      year: 0,
      month: 0,
      day: 0
    }

    if (format === DEFAULT_BACKEND_DATE_FORMAT) {
      t.year = parseInt(splitDate[2], 10)
      t.month = parseInt(splitDate[1], 10) - 1
      t.day = parseInt(splitDate[0], 10)
    }

    if (format === DEFAULT_BACKEND_DATE_FORMAT_REVERSE) {
      t.year = parseInt(splitDate[0], 10)
      t.month = parseInt(splitDate[1], 10) - 1
      t.day = parseInt(splitDate[2], 10)
    }

    const hours = splitTime && splitTime[0] ? parseInt(splitTime[0], 10) : 0
    const minutes = splitTime && splitTime[1] ? parseInt(splitTime[1], 10) : 0
    const seconds = splitTime && splitTime[2] ? parseInt(splitTime[2], 10) : 0

    return new Date(t.year, t.month, t.day, hours, minutes, seconds)
  }
  return new Date()
}
